import createApiClient from "./api";

const client = createApiClient();

export const api = {
  getAuditLogs: ({
    orgId,
    method,
    statusCode,
    path,
    from,
    to,
    perPage,
    currentPage,
  } = {}) => {
    const params = new URLSearchParams();
    if (orgId) params.append("organizationId", orgId);
    if (method) params.append("method", method);
    if (statusCode) params.append("statusCode", statusCode);
    if (path) params.append("path", path);
    if (from) params.append("from", from);
    if (to) params.append("to", to);
    params.append("perPage", perPage || 25);
    params.append("page", currentPage || 1);

    return client
      .get(`admin/audit-logs?${params.toString()}`)
      .then(({ data }) => data);
  },
};
